module.exports = __webpack_public_path__ + "static/sw-card-back-2689e4637451cf84c083826e19239c49.png";